/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Speakers_Metrics_By_PrefixInputs */

const en_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

const fr_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

const de_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

const it_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

const ru_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

const es_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

const zh_cn2_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

const ja_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

const hi_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

const pt_pt2_speakers_metrics_by_prefix = /** @type {(inputs: Speakers_Metrics_By_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By: ${i?.email}`)
};

/**
* | output |
* | --- |
* | "By: {email}" |
*
* @param {Speakers_Metrics_By_PrefixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_by_prefix = /** @type {((inputs: Speakers_Metrics_By_PrefixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_By_PrefixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_by_prefix(inputs)
	if (locale === "de") return de_speakers_metrics_by_prefix(inputs)
	if (locale === "it") return it_speakers_metrics_by_prefix(inputs)
	if (locale === "ru") return ru_speakers_metrics_by_prefix(inputs)
	if (locale === "es") return es_speakers_metrics_by_prefix(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_by_prefix(inputs)
	if (locale === "ja") return ja_speakers_metrics_by_prefix(inputs)
	if (locale === "hi") return hi_speakers_metrics_by_prefix(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_by_prefix(inputs)
	return en_speakers_metrics_by_prefix(inputs)
});